export const getInjectionDataType = (name) => {
    // mode = 1 : injection props else 2 : injection fields
    // return mode === 1 ? `${name}_injection_props` : `${name}_injection_fields`

    // return `${name}_injection_props`

    return `${name}_injection_fields`
}